import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Button } from '@material-ui/core';
import ArrowBack from '@material-ui/icons/ArrowBack';
import {
  DASHBOARD_REST_TABLES_INFO_CREATE,
  DASHBOARD_REST_TABLES_INFO_VIEW,
} from '../../../../../constants/DashboardConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_RESTAURANT,
} from '../../../../../constants/RoleConsts';
import './TableInfoView.scss';

const TableInfoView = (props) => {
  const { obj, onViewToggle, previousObj, permissions, toggleDrawer, allDashboardRestList } = props;
  const [reservation, setReservation] = useState([]);

  useEffect(() => {
    const reseDetails = allDashboardRestList.filter((revList) => {
      return obj?.reservations?.some((timeList) => {
        const getDate = timeList.split('#')[4];
        if (getDate === moment().format('YYYY-MM-DD')) {
          const getBothTime = timeList.split('#')[6];
          const tableNumber = revList.tableNumbers.some((tn) => tn === obj.tableNumber);
          if (
            tableNumber &&
            getBothTime.split('-')[0] === revList.reserveFrom &&
            getBothTime.split('-')[1] === revList.reserveUntil
          )
            return true;
        }
        return false;
      });
    });
    setReservation(reseDetails);
  }, [allDashboardRestList, obj]);

  return (
    <div className='container pb-2'>
      <div className='d-flex gap-2 flex-wrap py-2'>
        <div className='col px-0 d-flex align-items-center'>
          <Button
            variant='text'
            color='secondary'
            size='small'
            startIcon={<ArrowBack />}
            onClick={() => onViewToggle(DASHBOARD_REST_TABLES_INFO_VIEW, true, previousObj)}
          >
            Back
          </Button>
          <span className='page-title'>Table {('0' + obj.tableNumber).slice(-2)}</span>
        </div>
        <div className='col d-flex justify-content-end'>
          {!!permissions &&
            permissions[RBAC_TYPE_HOTEL_RESTAURANT] === RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
              <Button
                variant='outlined'
                color='primary'
                size='small'
                onClick={() => toggleDrawer(DASHBOARD_REST_TABLES_INFO_CREATE, true, obj)}
              >
                Edit
              </Button>
            )}
        </div>
      </div>
      <div className='card shadow mt-4 mb-4 pb-5 h-100 px-4'>
        <div className='row mt-4'>
          <div className='row mx-4 mt-4 resv-table-info-view'>
            <div className='col-md-4'>
              <p className='title'>Table No</p>
              <p className='details-value'>{('0' + obj.tableNumber).slice(-2)}</p>
            </div>
            <div className='col-md-4'>
              <p className='title'>Exposure</p>
              <p className='details-value'>{obj.exposure}</p>
            </div>
            <div className='col-md-4'>
              <p className='title'>Status</p>
              <p
                className={`${obj.className} w-20 pill justify-content-center align-objs-center py-2`}
              >
                {obj.status}
              </p>
            </div>
          </div>
          <div className='row mx-4 mt-4 resv-table-info-view'>
            <div className='col-md-4'>
              <p className='title'>Capacity</p>
              <p className='details-value'>{('0' + obj.capacity).slice(-2)}</p>
            </div>
            <div className='col-md-4'>
              <p className='title'>Slot Duration</p>
              <p className='details-value'>{obj.duration} min</p>
            </div>
          </div>
          <div className='row mx-4 mt-4 resv-table-info-view'>
            <div className='col-md-4'>
              <p className='title'>Bookings</p>
              <p className='details-value'>{obj.bookingCount}</p>
            </div>
          </div>
          {reservation.length > 0}
          <div className='row mx-4 mt-4 resv-table-info-view'>
            <div className='col-md-12'>
              <p className='title'>Booking information</p>
            </div>
            <div className='details-value'>
              {reservation.map((rese) => (
                <div className='col-md-9 mt-2 booking-details' key={rese.id}>
                  <div className='row'>
                    <div className='col-md-3'>
                      <p className='booking-details-title'>Guest Name</p>
                      <p className='booking-details-desc'>
                        {rese.firstName} {rese.lastName}
                      </p>
                    </div>
                    <div className='col-md-3'>
                      <p className='booking-details-title'>Arrival Time</p>
                      <p className='booking-details-desc'>
                        {moment(rese.reserveFrom, 'HH:mm').format('hh:mm A')}
                      </p>
                    </div>
                    <div className='col-md-3'>
                      <p className='booking-details-title'>No of Guests</p>
                      <p className='booking-details-desc'>{rese.noOfGuests}</p>
                    </div>
                    <div className='col-md-3'>
                      <p className='booking-details-title'>Special Request</p>
                      <p className='booking-details-desc'>{rese.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableInfoView;
